import { Form } from '@unform/web';
import $ from 'jquery';
import 'jquery-mask-plugin/dist/jquery.mask.min';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Alert } from '../../components/Alert';
import Input from '../../components/Forms/Input';
import { Loading } from '../../components/Loading';
import { login } from '../../services/auth';
import { ehCpfValido, ehEmailValido } from '../../services/utils';
import './style.css';

const Identificacao = () => {
    const { vestibular } = useParams();
    const location = useLocation();
    const history = useHistory();

    const { from } = location.state || { from: { pathname: '/' } };

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        $('#cpf').mask('000.000.000-00', { reverse: true });
    }, []);

    const handleSignIn = async data => {
        const { cpf, email } = data;

        if (!cpf || !email) {
            setError('Preencha CPF e/ou E-mail para continuar!');
        } else if (!ehCpfValido(cpf)) {
            setError('CPF inválido!');
        } else if (!ehEmailValido(email)) {
            setError('Email inválido!');
        } else {
            setLoading(true);
            try {
                await login(cpf, email.trim(), vestibular);
                history.push(from.pathname);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        }
    };

    return (
        <div className="content">
            <div className="f-header-content f-header-content--centralizado">
                <h1 className="f-header-content_title"> Identifique-se </h1>
            </div>
            <div className="container-fluid center">
                <div className="flex-fill w-100 card card-login">
                    <div className="card-body">
                        {error && <Alert variant="danger">{error}</Alert>}
                        {loading && <Loading />}
                        <Form className="" onSubmit={handleSignIn} autoComplete="off">
                            <div className="form-group">
                                <Input id="cpf" name="cpf" label="CPF" placeholder="Entre com o seu CPF" className="form-control-lg form-control"></Input>
                            </div>
                            <div className="form-group">
                                <Input name="email" label="E-mail" placeholder="E-mail utilizado na inscrição" className="form-control-lg form-control"></Input>
                            </div>
                            <div className="text-center mt-3">
                                <button type="submit" id="avancar" className="btn btn-primary btn-lg">
                                    Avançar
                                </button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Identificacao;
